import { Button, Container, Flex } from "@mantine/core";
import { IconCheck, IconPlayerSkipForward, IconX } from "@tabler/icons-react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { JobTaskDetailSchema } from "@augmodo/lebron-browser-client";
import { useParams } from "react-router-dom";
import { useCompleteJobTask } from "@labeling-tools/api/lebron/react-query-hooks/useCompleteJobTask";
import { useSkipJobTask } from "@labeling-tools/api/lebron/react-query-hooks";
import { PRODUCT_ASSOCIATION_MODEL_ID } from "../config/data";
import { useQueryClient } from "@tanstack/react-query";
import { reset } from "@/store";

export const ProductAssociationActions = ({
  task,
}: {
  task: JobTaskDetailSchema;
}) => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const selectedItem = useAppSelector(
    (state) => state.productAssociation.selectedItem,
  );
  const searchTerms = useAppSelector(
    (state) => state.productAssociation.searchTerms,
  );
  const selectedPlanogramId = useAppSelector(
    (state) => state.productAssociation.selectedPlanogramId,
  );
  const badDetection = useAppSelector(
    (state) => state.productAssociation.badDetection,
  );
  const { jobId } = useParams<{ jobId: string }>();
  // const transformStyle = selectedItem ? 'translateY(0%)' : 'translateY(100%)';
  const transformStyle = "translateY(0%)";
  const { mutateAsync: completeJobTask } = useCompleteJobTask(
    jobId || "",
    task.id || "",
  );

  const { mutateAsync: skipJobTask } = useSkipJobTask(
    jobId || "",
    task.id || "",
  );

  const handleNext = async () => {
    const resultData = {
      entity_id: selectedItem?.entity_id,
      embedding_id: selectedItem?.id,
      model_id: PRODUCT_ASSOCIATION_MODEL_ID,
      search_terms: searchTerms,
      planogram_id: selectedPlanogramId,
      planogram_submitted: false,
      bad_detection: badDetection,
    };
    await completeJobTask({
      result: resultData,
    });
    dispatch(reset());
    queryClient.invalidateQueries({ queryKey: ["nextPendingTask", jobId] });
  };

  const handleSkip = async () => {
    // TODO: add back if we need skip reasons
    // await skipJobTask({
    //   result: {
    //     skip_reasons: ["NOT_AN_ITEM"],
    //     skip_notes: "Not an item",
    //     search_terms: searchTerms,
    //   },
    // });
    const resultData = {
      model_id: PRODUCT_ASSOCIATION_MODEL_ID,
      search_terms: searchTerms,
      skip: true,
      planogram_submitted: false,
      bad_detection: badDetection,
    };
    await skipJobTask({
      result: resultData,
    });
    dispatch(reset());
    queryClient.invalidateQueries({ queryKey: ["nextPendingTask", jobId] });
  };

  const handleNotAnItem = async () => {
    const resultData = {
      entity_id: "NOT_FOUND",
      search_terms: searchTerms,
      model_id: PRODUCT_ASSOCIATION_MODEL_ID,
      planogram_submitted: false,
      bad_detection: badDetection,
    };
    await completeJobTask({
      result: resultData,
    });
    dispatch(reset());
    queryClient.invalidateQueries({ queryKey: ["nextPendingTask", jobId] });
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 p-4 transition-transform duration-300"
      style={{ transform: transformStyle }}
    >
      <Container size="lg">
        <Flex justify="center" gap="md">
          <Button
            size="md"
            className="min-w-[120px]"
            color="red"
            variant="subtle"
            onClick={handleNotAnItem}
          >
            <IconX />
            Not an Item
          </Button>
          <Button
            size="md"
            className="min-w-[120px]"
            color="gray"
            variant="outline"
            onClick={handleSkip}
          >
            <IconPlayerSkipForward />
            Skip
          </Button>
          <Button
            size="md"
            className="min-w-[120px]"
            onClick={handleNext}
            disabled={!selectedItem}
          >
            <IconCheck />
            Next
          </Button>
        </Flex>
      </Container>
    </div>
  );
};
